// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-15T11:49:17Z                      #

// ##############################################################


export const CEKA = 'CEKA';

export const ZPRAC = 'ZPRAC';

export const VYRIZ = 'VYRIZ';

export const ZDCEN = 'ZDCEN';

export const STORN = 'STORN';

export const CEKAVYJ = 'CEKAVYJ';

export const EXP = 'EXP';

/**
 * Seznam všech hodnot.
 */
export const values = [
    CEKA,
    ZPRAC,
    VYRIZ,
    ZDCEN,
    STORN,
    CEKAVYJ,
    EXP
];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [CEKA]: {caption: ''},
    [ZPRAC]: {caption: ''},
    [VYRIZ]: {caption: ''},
    [ZDCEN]: {caption: ''},
    [STORN]: {caption: ''},
    [CEKAVYJ]: {caption: ''},
    [EXP]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}